PJQ.views.addressbook.AddressBook = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'AddressBook'),
        selectContactGroupsMode: false,
        isShowHeader: true,
        directoryFilter: PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY,
        selectionMode: PJQ.constants.addressBook.selectionMode.NONE,
        disabledContacts: [],
        disabledContactGroups: [],
        onSelection: _.noop
    },
    events: {
        'keyup .input-search': 'searchChanged',
        'click .basic-search': 'search',
        'click .advanced-search': 'advancedSearch',
        'click .filter-groups': 'filterGroups',
        'click .clear-search': 'clearFilter',
        'click .btn-address-book-settings': 'settings',
        'click a.import': 'import',
        'click a.export': 'export',
        'click .merge': 'beginMerge',
        'click .merge-continue': 'continueMerge',
        'click .merge-cancel': 'cancelMerge',
        'click .new-contact': 'addContactClicked',
        'click .proqual-screening': 'proqualScreening',
        'click .proqual-filter>div': 'proqualFilterClicked',
        'click .btn-approval-queue': 'viewApprovalQueue',
        'click a.updaters': 'beginSendUpdater',
        'click .updater-continue': 'continueUpdater',
        'click .updater-cancel': 'cancelUpdater',
        'click .qualifications-report': 'qualificationsReport'
    },
    viewApprovalQueue: function () {
        this.approvalQueueSelector.setValue([1]);
        this.renderView();
    },
    onApprove() {
        let apprCount = PJQ.app.session.set('unApprovedContactsCount');
        if (apprCount == null) {
            apprCount = 0;
        } else if (apprCount <= 0) {
            apprCount = 0;
        } else {
            apprCount--;
        }
        PJQ.app.session.set('unApprovedContactsCount', apprCount);
        this.renderApprovalHeader();
    },
    fetchStats: function () {
        new PJQ.ajax.Request({
            endpoint: '/addressbook/stats'
        }).get().done(_.bind(function (data) {
            PJQ.app.session.set('unApprovedContactsCount', data.unApprovedContactsCount);
            this.renderApprovalHeader();
        }, this));
    },
    renderApprovalHeader: function () {
        let $alert = this.$('.approval-alert');
        $alert.empty();
        if (PJQ.app.session.get('unApprovedContactsCount') > 0) {
            new PJQ.Alert($alert, {
                text: PJQ.app.session.get('unApprovedContactsCount').toString() + ' contacts are in the approval queue.  <a href="javascript:void(0)" class="btn-approval-queue font-weight-bold" style="text-decoration: underline !important;">Click here</a> or filter to unapproved contacts to review them.'
            });
        }
    },
    beforeFirstRender: function () {
        this.isAdvancedSearch = false;
        this.isShowCheckboxes = false;
        this.isMerge = false;
        this.showApproval = this.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE && (PJQ.app.session.hasPermission('contacts.canApprove') || PJQ.app.session.hasPermission('contacts.canViewApproval'));
        this.showLaborStatus = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
        this.isInitialLoad = true;

        this.advancedSearch = null;
        this.selectedContactsAll = [];
        this.selectedContactGroups = [];
        this.selectedContactsNoGroup = [];

        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            this.isShowCheckboxes = true;
            this.isShowHeader = false;
        }

        this.isSettingsFetched = false;
        this.filter = {
            searchFor: '',
            locationFilter: PJQ.constants.addressBook.locationTypeFilter.WORK_AREA,
            zip: '',
            radius: 0,
            directoryFilter: PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY,
            userTypeFilter: 0,
            groups: []
        };

        this.proqualStatistics = new PJQ.models.addressBook.ProqualStatistics();
        this.settings = new PJQ.models.addressBook.AddressBookViewSettings();
        this.settings.fetch({
            success: _.bind(function () {
                this.isSettingsFetched = true;
                this.currentView = this.settings.get('defaultView');
                PJQ.app.session.fetchCompanyCustomFields(PJQ.app.session.get("masterUserId"), _.bind(function () {
                    PJQ.app.session.fetchContactCustomFields(PJQ.app.session.get("masterUserId"), _.bind(function () {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS)) {
                            this.proqualStatistics.fetch({
                                success: _.bind(function () {
                                    PJQ.app.session.fetchScreeningSettings(_.bind(function (settings) {
                                        this.screeningSettings = settings;
                                        this.render();
                                    }, this))
                                }, this)
                            });
                        } else
                            this.render();
                    }, this));
                }, this));
            }, this)
        });
    },
    renderData: function () {
        return {
            showHeader: this.options.isShowHeader,
            showScreenings: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS),
            showProqual: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_CUSTOMER),
            proqualStatistics: this.proqualStatistics.attributes,
            showGroupCompanyView: true, // todo: read from preferences
            showGroupContactView: true, // todo: read from preferences
            showApproval: this.showApproval,
            showLaborStatus: this.showLaborStatus,
            canAdd: PJQ.app.session.hasPermission('contacts.canAddContact'),
            settingsFetched: this.isSettingsFetched,
            selectionMode: this.options.selectionMode,
            canExport: PJQ.app.session.hasPermission('contacts.canExport'),
            canImport: PJQ.app.session.hasPermission('contacts.canImport'),
            canMerge: PJQ.app.session.hasPermission('contacts.canMerge')
        };
    },
    afterRender: function () {
        if (!this.isSettingsFetched)
            return;

        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            this.$('.proqual-screening, .other-actions').prop('disabled', true);
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.address-book-view'),
            defaultValue: this.currentView,
            onChange: _.bind(function (value) {
                this.isInitialLoad = true;
                this.renderView(value);
            }, this)
        });

        if (this.showApproval) {
            this.fetchStats();
            this.approvalQueueSelector = new PJQ.inputs.Selectpicker({
                el: this.$('.select-approval'),
                isIntChoices: true,
                defaultValue: [0],
                isMultiple: true,
                noneSelectedText: "Select Approval Status",
                onChange: _.bind(function () {
                    if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH)) {
                        this.renderView();
                    }
                }, this)
            });
        }

        this.locationType = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS).split(',') : [PJQ.constants.addressBook.locationTypeFilter.WORK_AREA, PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION]
        this.locationTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-location-type'),
            isIntChoices: true,
            isMultiple: true,
            mustSelectValue: true,
            defaultValue: this.locationType
        });

        this.radiusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-radius'),
            isIntChoices: true,
            defaultValue: 0
        });

        /* not sure this is needed given how new UI works
        let publicContactInfo = 'You must enter a search zip code to view public subcontractors.';
        if (this.options.directoryFilter === PJQ.constants.addressBook.directoryFilter.ALL_CONTACTS ||
            this.options.directoryFilter === PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY) {
            this.showNotification(publicContactInfo, 'info');
        }
         */
        let defaultFilters = null
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_FILTERS)) {
            defaultFilters = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_FILTERS).split(',');
            if (this.showApproval)
                defaultFilters.push(PJQ.constants.addressBook.approvalFilter.APPROVED);
        } else {
            defaultFilters = _.map(PJQ.app.session.userTypes.getByIsCompany(false), function (userType) {
                return userType.get('userTypeId');
            });

            $.merge(defaultFilters, [PJQ.constants.addressBook.contactStatusFilter.ACTIVE, PJQ.constants.addressBook.contactStatusFilter.INACTIVE]);
            if (this.showLaborStatus)
                $.merge(defaultFilters, [PJQ.constants.addressBook.laborStatusFilter.UNION, PJQ.constants.addressBook.laborStatusFilter.NON_UNION, PJQ.constants.addressBook.laborStatusFilter.PREV_WAGE, PJQ.constants.addressBook.laborStatusFilter.NOT_AVAILABLE]);
            if (this.showApproval)
                defaultFilters.push(PJQ.constants.addressBook.approvalFilter.APPROVED);
        }

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_DISPLAY_DIRECTORY)) {
            switch (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_DISPLAY_DIRECTORY)) {
                case 0:
                    $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY, PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY]);
                    break;
                case 1 || -1:
                    $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY]);
                    break;
                default:
                    $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY]);
            }
        } else {
            $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY])
        }

        this.filterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter'),
            isIntChoices: true,
            isMultiple: true,
            exclusiveChoices: [-3, -4],
            isGroup: true,
            mustSelectValuePerOptGroup: true,
            defaultValue: defaultFilters,
            onHide: _.bind(function () {
                if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH)) {
                    if ((_.size(this.lastFilter) !== _.size(this.filterSelectPicker.getValue())) ||
                        (_.size(this.lastFilter) !== _.size(_.uniq(_.union(this.lastFilter, this.filterSelectPicker.getValue())))))
                        this.renderView();
                }
            }, this)
        });
        this.renderView();
    },
    hideNotification: function () {
        this.$('.address-book-notifications').hide();
    },
    showNotification: function (content, type) {
        this.$('.address-book-notifications').removeClass('alert-primary').removeClass('alert-secondary').removeClass('alert-info').removeClass('alert-success').removeClass('alert-warning').removeClass('alert-danger');
        this.$('.address-book-notifications').addClass('alert-' + type);

        let icon = '';
        switch (type) {
            case 'info':
                icon = '<i class="fas fa-info-circle fa-xs"></i>';
                break;
        }

        this.$('.address-book-notifications').html(icon + (icon ? ' ' : '') + content);
        this.$('.address-book-notifications').show();
    },
    renderView: function (view, options = {}) {
        this.currentView = view ? view : this.currentView;

        let page = null;
        if (options.stayOnPage && this.dataTable != null) {
            page = this.dataTable.dataTable.page();
        }

        if (this.dataTable) {
            this.dataTable.cleanup();
            this.dataTable.clearServerCache = true;
            this.dataTable.pageCache = [];
            this.dataTable.remove();
            this.dataTable = null;
            this.$('.addressbook-data').empty();
        }

        let self = this, tableSettings = this.settings.getSettings(this.currentView),
            dataTableOptions = {
                el: this.$('.addressbook-data'),
                language: {
                    zeroRecords: (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH) && this.isInitialLoad) ? " " : "No Results Available"
                },
                data: null,
                view: this.currentView,
                addressBookView: this,
                userSettings: this.settings,
                settings: tableSettings,
                getPageCallback: _.bind(this.getViewData, this),
                displayStart: page != null ? page * tableSettings.rowsPerPage : null,
                deferRender: true,
                clearServerCache: true,
                isShowCheckboxes: this.isShowCheckboxes,
                onApprove: _.bind(this.onApprove, this),
                showPageSelector: true,
                onTableDraw: _.bind(function (dataTable) {
                    this.$('.addressbook-data').css('margin-top', -40);
                }, this),
                beforeDataTableRender: function() {
                    if (this.settings) {
                        let fixedColumnsLeft = 0;
                        switch (this.settings.view) {
                            case PJQ.constants.addressBook.view.TRADES_COMPANY:
                            case PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP:
                            case PJQ.constants.addressBook.view.TRADES_CONTACT:
                            case PJQ.constants.addressBook.view.TRADES_CONTACT_GROUP:
                            case PJQ.constants.addressBook.view.CONTACT_GROUP:
                                fixedColumnsLeft = 1;

                                break;
                            case PJQ.constants.addressBook.view.COMPANY:
                            case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY:
                                fixedColumnsLeft = self.isShowCheckboxes ? 2 : 1;

                                break;
                            case PJQ.constants.addressBook.view.CONTACT:
                            case PJQ.constants.addressBook.view.COMPANY_CONTACT:
                            case PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT:
                            case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY_CONTACT:
                                fixedColumnsLeft = self.isShowCheckboxes ? 1 : 0;

                                if (self.options.selectionMode == PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                                    fixedColumnsLeft++;
                                }
                                break;
                            default:
                                break;
                        }
                        this.colReorder = {
                            fixedColumnsLeft: fixedColumnsLeft,
                            realtime: false
                        };
                    }
                }
            };

        this.dataTable = this.getDataTableInstance(dataTableOptions);

        if (this.options.contactId > 0) {
            let initContact = new PJQ.models.contacts.Contact({
                id: this.options.contactId
            });
            this.options.contactId = null;
            initContact.fetch({
                success: _.bind(function () {
                    this.dataTable.editContact(initContact);
                }, this)
            })
        }
    },
    updateFilter: function () {
        if ((PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH) && !this.isInitialLoad) || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH)) {
            let filter = this.filterSelectPicker.getValue();
            this.lastFilter = filter;

            this.filter.searchFor = this.$('.input-search').val();

            if (this.filter.searchFor.length <= 15 && PJQ.helpers.formatHelpers.numbersOnly(this.filter.searchFor).length == 10)
                this.filter.searchFor = PJQ.helpers.formatHelpers.numbersOnly(this.filter.searchFor);

            this.filter.locationFilter = 0;
            if (this.locationTypeSelectPicker.getValue().indexOf(PJQ.constants.addressBook.locationTypeFilter.WORK_AREA) !== -1 && this.locationTypeSelectPicker.getValue().indexOf(PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION) !== -1)
                this.filter.locationFilter = PJQ.constants.addressBook.locationTypeFilter.BOTH;
            else if (this.locationTypeSelectPicker.getValue().indexOf(PJQ.constants.addressBook.locationTypeFilter.WORK_AREA) !== -1)
                this.filter.locationFilter = PJQ.constants.addressBook.locationTypeFilter.WORK_AREA;
            else if (this.locationTypeSelectPicker.getValue().indexOf(PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION) !== -1)
                this.filter.locationFilter = PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION;

            this.filter.zip = this.$('.input-search-zip').val().replace(' ', '').replace('-', '');
            if (_.size(this.filter.zip) === 6) {
                this.filter.zip = this.filter.zip.substring(0, 3) + ' ' + this.filter.zip.substring(3, 6);
            }
            this.filter.radius = this.radiusSelectPicker.getValue();

            this.filter.directoryFilter = PJQ.constants.addressBook.directoryFilter.ALL_CONTACTS;
            if (filter.indexOf(PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY) === -1)
                this.filter.directoryFilter = PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY * -1;
            else if (filter.indexOf(PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY) === -1)
                this.filter.directoryFilter = PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY * -1;

            let $exportBtn = this.$('.dropdown-item.export'),
                $alert = this.$('.public-zip-alert');
            $alert.empty();
            if (this.filter.directoryFilter === PJQ.constants.addressBook.directoryFilter.ALL_CONTACTS || this.filter.directoryFilter === PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY * -1) {
                new PJQ.Alert($alert, {
                    text: 'You must enter a search ZIP Code to view public subcontractors.'
                });
                $exportBtn.addClass('hidden');
            } else {
                $exportBtn.removeClass('hidden');
            }

            this.filter.userTypeFilter = _.filter(filter, function (value) {
                return value > 0;
            });

            this.filter.isPrimaryOnly = filter.indexOf(PJQ.constants.addressBook.miscFilter.PRIMARY_CONTACT_ONLY) !== -1;

            this.filter.isFilterActive = filter.indexOf(PJQ.constants.addressBook.contactStatusFilter.ACTIVE) !== -1;
            this.filter.isFilterInactive = filter.indexOf(PJQ.constants.addressBook.contactStatusFilter.INACTIVE) !== -1;

            this.filter.isFilterUnion = filter.indexOf(PJQ.constants.addressBook.laborStatusFilter.UNION) !== -1;
            this.filter.isFilterNonUnion = filter.indexOf(PJQ.constants.addressBook.laborStatusFilter.NON_UNION) !== -1;
            this.filter.isFilterPrevWage = filter.indexOf(PJQ.constants.addressBook.laborStatusFilter.PREV_WAGE) !== -1;
            this.filter.isFilterNoLaborStatus = filter.indexOf(PJQ.constants.addressBook.laborStatusFilter.NOT_AVAILABLE) !== -1;

            this.filter.isFilterApproved = this.approvalQueueSelector && this.approvalQueueSelector.getValue().indexOf(0) !== -1;
            this.filter.isFilterUnapproved = this.approvalQueueSelector && this.approvalQueueSelector.getValue().indexOf(1) !== -1;

            this.filter.proqualFilter = this.$('div.proqual-filter>div.selected').data('filter');
        } else {
            this.isInitialLoad = false;
        }
    },
    getViewData: function (pageNumber, pageSize, orderArr, callback) {
        this.updateFilter();

        let order = orderArr[0];
        this.data = new PJQ.collections.addressBook.AddressBookViewResults(null, {
            view: this.currentView
        });

        switch (this.currentView) {
            case PJQ.constants.addressBook.view.COMPANY:
                switch (order.name) {
                    case 'contactName':
                        order.name = 'primaryContactName';
                        break;
                    case 'contactTitle':
                        order.name = 'primaryContactTitle';
                        break;
                    case 'contactUserType':
                        order.name = 'primaryContactUserType';
                        break;
                    case 'contactAddress1':
                        order.name = 'primaryAddress1';
                        break;
                    case 'contactAddress2':
                        order.name = 'primaryAddress2';
                        break;
                    case 'city':
                        order.name = 'primaryCity';
                        break;
                    case 'state':
                        order.name = 'primaryState';
                        break;
                    case 'zip':
                        order.name = 'primaryZip';
                        break;
                    case 'country':
                        order.name = 'primaryCountry';
                        break;
                    case 'phone':
                        order.name = 'primaryPhone';
                        break;
                    case 'fax':
                        order.name = 'primaryFax';
                        break;
                    case 'cell':
                        order.name = 'primaryCell';
                        break;
                    case 'email':
                        order.name = 'primaryEmail';
                        break;
                }
                break;
        }

        this.data.fetch({
            data: {
                searchFor: this.filter.searchFor,
                locationFilter: this.filter.locationFilter,
                zip: this.filter.zip,
                radius: this.filter.radius,
                directoryFilter: this.filter.directoryFilter,
                userTypeFilter: this.filter.userTypeFilter,
                groups: this.filter.groups,
                page: pageNumber,
                pageSize: pageSize,
                orderBy: order.name,
                orderDirection: order.direction,
                isAdvancedSearch: this.isAdvancedSearch,
                advancedSearch: this.advancedSearch,
                showGroupDescription: this.settings.getSettings(this.currentView).showGroupDescription,
                isPrimaryOnly: this.filter.isPrimaryOnly,
                isFilterApproved: this.filter.isFilterApproved,
                isFilterUnapproved: this.filter.isFilterUnapproved,
                proqualFilter: this.filter.proqualFilter,
                isFilterActive: this.filter.isFilterActive,
                isFilterInactive: this.filter.isFilterInactive,
                isFilterUnion: this.filter.isFilterUnion,
                isFilterNonUnion: this.filter.isFilterNonUnion,
                isFilterPrevWage: this.filter.isFilterPrevWage,
                isFilterNoLaborStatus: this.filter.isFilterNoLaborStatus,
                isIncludeGroupList: this.settings.hasGroupListColumn(this.currentView),
                includeScreeningPackages: this.settings.hasScreeningPackagesColumn(this.currentView),
                includeContactCustomFields: this.settings.getContactCustomFieldColumns(this.currentView),
                includeCompanyCustomFields: this.settings.getCompanyCustomFieldColumns(this.currentView),
                isSelectionMode: !(this.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE)
            },
            type: 'POST',
            success: _.bind(function () {
                callback(this.data.models, this.data.totalRows);
                if (this.pageSelectPicker == null) {
                    // this.renderPageSelect();
                }
            }, this),
            fail: _.bind(function () {
                callback();
            }, this)
        });
    },
    getDataTableInstance: function (options) {
        let dataTable = null;

        switch (options.view) {
            case PJQ.constants.addressBook.view.CONTACT:
            case PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT:
            case PJQ.constants.addressBook.view.COMPANY_CONTACT:
            case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY_CONTACT:
                dataTable = new PJQ.views.addressbook.ContactDataTable(options);
                break;
            case PJQ.constants.addressBook.view.COMPANY:
            case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY:
                dataTable = new PJQ.views.addressbook.CompanyDataTable(options);
                break;
            case PJQ.constants.addressBook.view.TRADES_COMPANY:
            case PJQ.constants.addressBook.view.TRADES_CONTACT:
                dataTable = new PJQ.views.addressbook.GroupHeaderDataTable(options);
                break;
            case PJQ.constants.addressBook.view.CONTACT_GROUP:
                dataTable = new PJQ.views.addressbook.ContactGroupDataTable(options);
                break;
        }
        return dataTable;
    },
    selectAll: function (checked, groupDescription, callback) {
        let selections = new PJQ.collections.addressBook.AddressBookSelections();
        selections.fetch({
            data: {
                searchFor: this.filter.searchFor,
                locationFilter: this.filter.locationFilter,
                zip: this.filter.zip,
                radius: this.filter.radius,
                directoryFilter: this.filter.directoryFilter,
                userTypeFilter: this.filter.userTypeFilter,
                groups: this.filter.groups,
                isAdvancedSearch: this.isAdvancedSearch,
                advancedSearch: this.advancedSearch,
                showGroupDescription: this.settings.getSettings(this.currentView).showGroupDescription,
                groupDescription: groupDescription,
                isPrimaryOnly: this.filter.isPrimaryOnly || (this.proqualRequest != null),
                isFilterApproved: this.filter.isFilterApproved,
                isFilterUnapproved: this.filter.isFilterUnapproved,
                proqualFilter: this.filter.proqualFilter,
                isFilterActive: this.filter.isFilterActive,
                isFilterInactive: this.filter.isFilterInactive,
                isFilterUnion: this.filter.isFilterUnion,
                isFilterNonUnion: this.filter.isFilterNonUnion,
                isFilterPrevWage: this.filter.isFilterPrevWage,
                isFilterNoLaborStatus: this.filter.isFilterNoLaborStatus,
                isSelectionMode: !(this.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE)
            },
            type: 'POST',
            success: _.bind(function () {

                let contacts = [], contactGroups = [], contactsNoGroup = [];
                _.each(selections.models, _.bind(function (selection) {
                    contacts.push(selection.get('contactId'));
                    if (_.size(selection.get('groups')) > 0) {
                        $.merge(contactGroups, selection.get('groups'));
                    } else {
                        contactsNoGroup.push(selection.get('contactId'));
                    }
                }, this));

                if (checked) {
                    this.addSelectedContactsAll(contacts);
                    this.addSelectedContactGroups(contactGroups);
                    this.addSelectedContactsNoGroup(contactsNoGroup);
                } else {
                    this.removeSelectedContactsAll(contacts);
                    this.removeSelectedContactGroups(contactGroups);
                    this.removeSelectedContactsNoGroup(contactsNoGroup);
                }

                callback();
            }, this)
        });

    },
    enableBasicSearch: function (enabled) {
        this.$('.input-search,.input-search-zip,.filter-groups,.basic-search, input.proqual-filter').prop('disabled', !enabled);

        if (!enabled)
            this.$('div.proqual-filters label').removeClass('active');

        if (enabled) {
            this.locationTypeSelectPicker.enable();
            this.radiusSelectPicker.enable();
            this.filterSelectPicker.enable();
        } else {
            this.locationTypeSelectPicker.disable();
            this.radiusSelectPicker.disable();
            this.filterSelectPicker.disable();
        }
    },
    filterGroups: function () {
        this.updateFilter();
        new PJQ.views.addressbook.FilterTradesModal({
            directoryFilter: this.filter.directoryFilter,
            selectedGroups: this.filter.groups,
            onFilter: _.bind(function (groups) {
                this.filter.groups = groups;
                this.$('.filter-groups-text').text((groups.length > 0 ? groups.length.toString() : 'All') + ' Trades');
                this.renderView();
            }, this)
        });
    },
    searchChanged: function (e) {
        if (e.keyCode === 13) {
            this.search();
        }
    },
    search: function () {
        this.renderView();
    },
    advancedSearch: function () {
        let settings = new PJQ.models.addressBook.AddressBookAdvancedSearchSettings();
        settings.fetch({
            success: _.bind(function (data) {
                new PJQ.views.addressbook.AdvancedSearchModal({
                    advancedSearch: this.advancedSearch,
                    settings: settings,
                    onSearch: _.bind(function (search) {
                        this.isAdvancedSearch = true;
                        this.advancedSearch = search;
                        this.clearBasicSearch();
                        this.enableBasicSearch(false);
                        this.renderView();
                    }, this)
                });
            }, this)
        });

    },
    clearBasicSearch() {
        if ((PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH))) {
            this.isInitialLoad = true;
        }
        this.filter.searchFor = '';
        this.$('.input-search').val(this.filter.searchFor);

        this.filter.locationFilter = PJQ.constants.addressBook.locationTypeFilter.BOTH;
        this.locationTypeSelectPicker.setValue([PJQ.constants.addressBook.locationTypeFilter.WORK_AREA, PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION]);

        this.filter.zip = '';
        this.$('.input-search-zip').val(this.filter.zip);

        this.filter.radius = 0;
        this.radiusSelectPicker.setValue(this.filter.radius);

        this.filter.directoryFilter = PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY;
        this.filter.userTypeFilter = PJQ.app.session.userTypes.getByIsCompany(false)[0].get('userTypeId');
        this.filter.isFilterUnapproved = false;

        let defaultFilters = null
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_FILTERS)) {
            defaultFilters = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_FILTERS).split(',')
            $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY])
            if (this.showApproval)
                defaultFilters.push(PJQ.constants.addressBook.approvalFilter.APPROVED);
        } else {
            defaultFilters = _.map(PJQ.app.session.userTypes.getByIsCompany(false), function (userType) {
                return userType.get('userTypeId');
            });

            $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY, PJQ.constants.addressBook.contactStatusFilter.ACTIVE, PJQ.constants.addressBook.contactStatusFilter.INACTIVE]);

            if (this.showLaborStatus)
                $.merge(defaultFilters, [PJQ.constants.addressBook.laborStatusFilter.UNION, PJQ.constants.addressBook.laborStatusFilter.NON_UNION, PJQ.constants.addressBook.laborStatusFilter.PREV_WAGE, PJQ.constants.addressBook.laborStatusFilter.NOT_AVAILABLE]);
            if (this.showApproval)
                defaultFilters.push(PJQ.constants.addressBook.approvalFilter.APPROVED);
        }
        this.filterSelectPicker.setValue(defaultFilters);

        this.filter.groups = [];
        this.$('.filter-groups-text').text('All Trades');

        this.$('div.proqual-filters label').removeClass('active');
        this.$('input.proqual-filter-all').prop('checked', true).closest('label').addClass('active');
    },
    clearFilter: function (preventRefresh) {
        this.clearBasicSearch();
        this.isAdvancedSearch = false;
        this.advancedSearch = null;
        this.selectedContactsAll = [];
        this.selectedContactGroups = [];
        this.selectedContactsNoGroup = [];

        if (preventRefresh !== true) {
            this.enableBasicSearch(true);
            this.renderView();
        }
    },
    settings: function () {
        new PJQ.views.addressbook.AddressBookSettingsModal({
            addressBookView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    import: function () {
        new PJQ.views.contacts.ContactsImportModal({
            onClose: _.bind(function (isChanged) {
                if (isChanged) {
                    this.renderView();
                }
            }, this)
        });
    },
    export: function () {
        this.updateFilter();

        let orderBy = '', orderDirection = '', settings = null;

        switch (this.currentView) {
            case PJQ.constants.addressBook.view.TRADES_COMPANY:
            case PJQ.constants.addressBook.view.COMPANY:
                settings = this.settings.getSettings(PJQ.constants.addressBook.view.COMPANY);

                orderBy = settings.orderBy;
                orderAscending = settings.orderAscending ? 'asc' : 'desc';
                switch (orderBy) {
                    case 'contactName':
                        orderBy = 'primaryContactName';
                        break;
                    case 'contactTitle':
                        orderBy = 'primaryContactTitle';
                        break;
                    case 'contactAddress1':
                        orderBy = 'primaryAddress1';
                        break;
                    case 'contactAddress2':
                        orderBy = 'primaryAddress2';
                        break;
                    case 'city':
                        orderBy = 'primaryCity';
                        break;
                    case 'state':
                        orderBy = 'primaryState';
                        break;
                    case 'zip':
                        orderBy = 'primaryZip';
                        break;
                    case 'country':
                        orderBy = 'primaryCountry';
                        break;
                    case 'phone':
                        orderBy = 'primaryPhone';
                        break;
                    case 'fax':
                        orderBy = 'primaryFax';
                        break;
                    case 'cell':
                        orderBy = 'primaryCell';
                        break;
                    case 'email':
                        orderBy = 'primaryEmail';
                        break;
                }
                break;
            case PJQ.constants.addressBook.view.TRADES_CONTACT:
            case PJQ.constants.addressBook.view.CONTACT:
                settings = this.settings.getSettings(PJQ.constants.addressBook.view.CONTACT);
                orderBy = settings.orderBy;
                orderDirection = settings.orderAscending ? 'asc' : 'desc';
                break;
        }

        this.loader = new PJQ.Loader(this.$el);
        let dateNow = new Date(), vw = new PJQ.collections.addressBook.AddressBookViewResults(null, {
            view: this.currentView,
            isExport: true
        });
        vw.export({
            searchFor: this.filter.searchFor,
            locationFilter: this.filter.locationFilter,
            zip: this.filter.zip,
            radius: this.filter.radius,
            directoryFilter: this.filter.directoryFilter,
            userTypeFilter: this.filter.userTypeFilter,
            groups: this.filter.groups,
            page: 1,
            pageSize: 2147483646,
            orderBy: orderBy,
            orderDirection: orderDirection,
            isAdvancedSearch: this.isAdvancedSearch,
            advancedSearch: this.advancedSearch,
            showGroupDescription: this.settings.getSettings(this.currentView).showGroupDescription,
            isPrimaryOnly: this.filter.isPrimaryOnly,
            isFilterApproved: this.filter.isFilterApproved,
            isFilterUnapproved: this.filter.isFilterUnapproved,
            isFilterActive: this.filter.isFilterActive,
            isFilterInactive: this.filter.isFilterInactive,
            proqualFilter: this.filter.proqualFilter,
            isIncludeGroupList: this.settings.hasGroupListColumn(this.currentView),
            includeScreeningPackages: this.settings.hasScreeningPackagesColumn(this.currentView),
            includeContactCustomFields: this.settings.getContactCustomFieldColumns(this.currentView),
            includeCompanyCustomFields: this.settings.getCompanyCustomFieldColumns(this.currentView),
            timeZoneOffset: dateNow.getTimezoneOffset()
        }, _.bind(function (response) {
            this.loader.remove();
            if (response != null) {
                PJQ.files.downloadFile(response.url, {
                    isEndpoint: false
                });
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Export failed.'
                });
            }
        }, this));
    },
    qualificationsReport: function() {
        new PJQ.views.addressbook.QualificationsReportModal();
    },
    addContactClicked: function () {
        new PJQ.views.addressbook.EditCompanyModal({
            onSave: _.bind(function () {
                this.renderView(null, {
                    stayOnPage: true
                });
            }, this),
            onSaveContact: _.bind(function (contact, isNew) {
                if (isNew) {
                    this.addSelectedContactsAll([contact.get('contactId')]);
                    if (_.size(contact.get('contactGroups')) > 0) {
                        this.addSelectedContactGroups(contact.get('contactGroups'));
                    } else {
                        this.addSelectedContactsNoGroup([contact.get('contactId')]);
                    }
                }
            }, this),
            onApprove: _.bind(function () {
                this.fetchStats();
            }, this),
            onDelete: _.bind(function () {
                this.renderView(null, {
                    stayOnPage: true
                });
            }, this)
        });
    },
    proqualFilterClicked: function (e) {
        let $target = $(e.currentTarget),
            filter = $target.data('filter');
        this.$('.proqual-filter>div').removeClass('selected');
        $target.addClass('selected');
        this.renderView();
    },
    proqualScreening: function () {
        let request = this.proqualRequest ? this.proqualRequest : {};
        request.selectedContacts = this.selectedContactsAll;
        this.$('button.other-actions').prop('disabled', true);

        new PJQ.views.addressbook.ProqualRequestModal({
            request: request,
            onAddParticipants: _.bind(function (request) {
                // 2020-06-10 Per request they want to SEE all the contacts, but when they do SELECT ALL they want it to only select primary.   Therefore removing this auto-filter.
                //this.filterSelectPicker.setValue(_.union(this.filterSelectPicker.getValue(), [PJQ.constants.addressBook.miscFilter.PRIMARY_CONTACT_ONLY]));
                this.proqualRequest = request;
                this.$('.proqual-screening').html('<i class="fal fa-paper-plane mr-1"></i>Resume Qualifications');
                if (!this.isShowCheckboxes) {
                    this.isShowCheckboxes = true;
                    this.options.selectionMode = PJQ.constants.addressBook.selectionMode.PROQUAL;
                    this.renderView();
                }
            }, this),
            onClose: _.bind(function () {
                this.$('button.other-actions').prop('disabled', false);
                this.$('.proqual-screening').html('<i class="fal fa-paper-plane mr-1"></i>Request Qualifications');
                this.proqualRequest = null;
                if (this.isShowCheckboxes) {
                    this.isShowCheckboxes = false;
                    this.options.selectionMode = PJQ.constants.addressBook.selectionMode.NONE;
                    this.selectedContactsAll = [];
                    this.selectedContactGroups = [];
                    this.selectedContactsNoGroup = [];
                    this.renderView();
                }
            }, this)
        });
    },
    addSelectedContactsAll: function (contactIds) {
        this.selectedContactsAll = _.uniq(_.union(contactIds, this.selectedContactsAll));

        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.MERGE) {
            this.$('.merge-continue').prop('disabled', (_.size(this.selectedContactsAll) < 2));
        }
        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.UPDATER) {
            this.$('.updater-continue').prop('disabled', (_.size(this.selectedContactsAll) < 1));
        }

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    removeSelectedContactsAll: function (contactIds) {
        this.selectedContactsAll = _.without(this.selectedContactsAll, ...contactIds);

        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.MERGE) {
            this.$('.merge-continue').prop('disabled', (_.size(this.selectedContactsAll) < 2));
        }
        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.UPDATER) {
            this.$('.updater-continue').prop('disabled', (_.size(this.selectedContactsAll) < 1));
        }

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    addSelectedContactGroups: function (contactGroupIds) {
        if (this.options.disabledContactGroups == null) {
            this.options.disabledContactGroups = [];
        }
        this.selectedContactGroups = _.without(_.uniq(_.union(contactGroupIds, this.selectedContactGroups)), ...this.options.disabledContactGroups);

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    removeSelectedContactGroups: function (contactGroupIds) {
        this.selectedContactGroups = _.without(this.selectedContactGroups, ...contactGroupIds);

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    addSelectedContactsNoGroup: function (contactIds) {
        this.selectedContactsNoGroup = _.without(_.uniq(_.union(contactIds, this.selectedContactsNoGroup)), ...this.options.disabledContacts);

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    removeSelectedContactsNoGroup: function (contactIds) {
        this.selectedContactsNoGroup = _.without(this.selectedContactsNoGroup, ...contactIds);

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    beginMerge: function () {
        this.isShowCheckboxes = true;
        this.options.selectionMode = PJQ.constants.addressBook.selectionMode.MERGE;
        this.$('.other-actions, .proqual-screening, .merge-continue, .merge').prop('disabled', true);
        this.$('.merge-continue, .merge-cancel').show();
        this.showNotification('Select 2 or more contacts and click "Continue Merge" to continue.', 'info');
        this.renderView(null, {
            stayOnPage: true
        });
    },
    continueMerge: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'addressbook',
            },
            {
                endpoint: 'merge'
            },
            {
                endpoint: 'check'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                contacts: this.selectedContactsAll
            }
        }).post().done(_.bind(function (data) {
            if (_.size(data.response) < 2) {
                PJQ.notifications.notify.errorNotify({
                    title: 'Nothing to Merge!',
                    message: 'All selected contacts already belong to the same company.'
                });

                return;
            }

            new PJQ.views.addressbook.MergeRequestModal({
                data: data.response,
                addressBookView: this,
                onMerge: _.bind(function () {
                    this.cancelMerge();
                }, this)
            });
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    cancelMerge: function () {
        this.isShowCheckboxes = false;
        this.options.selectionMode = PJQ.constants.addressBook.selectionMode.NONE;
        this.selectedContactsAll = [];
        this.selectedContactGroups = [];
        this.selectedContactsNoGroup = [];
        this.$('.other-actions, .proqual-screening, .merge').prop('disabled', false);
        this.$('.merge-continue, .merge-cancel').hide();
        this.hideNotification();
        this.renderView();
    },
    beginSendUpdater: function (e) {
        let $target = $(e.currentTarget);
        this.updaterType = $target.data('updater');
        this.isShowCheckboxes = true;
        this.options.selectionMode = PJQ.constants.addressBook.selectionMode.UPDATER;
        this.$('.other-actions, .proqual-screening, .updater-continue, .btn-merge').prop('disabled', true);
        this.$('.updater-continue, .updater-cancel').show();
        this.showNotification('Select 1 or more contacts and click "Send Updater" to continue.', 'info');
        this.renderView(null, {
            stayOnPage: true
        });
    },
    continueUpdater: function () {
        let endpoint,
            header;
        if (this.updaterType === 'contact') {
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts'
                },
                {
                    endpoint: 'updater'
                }
            ]);
            header = "Send Contact Updaters"
        } else if (this.updaterType === 'prequal') {
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts'
                },
                {
                    endpoint: 'prequal'
                },
                {
                    endpoint: 'request'
                }
            ]);
            header = "Send Qualification Updaters"
        }
        new PJQ.views.modals.YesNo({
            header: header,
            body: 'Are you sure you want to send these contacts an Update Request?',
            onYes: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: endpoint,
                    data: {
                        contacts: this.selectedContactsAll
                    }
                }).post().done(_.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Successfully sent contact updaters'
                    });
                    this.cancelUpdater();
                }, this)).fail(function (xhr, err, result) {
                });
            }, this),
            onNo: _.bind(function () {
                this.cancelUpdater();
            }, this)
        })

    },
    cancelUpdater: function () {
        this.updaterType = null;
        this.isShowCheckboxes = false;
        this.options.selectionMode = PJQ.constants.addressBook.selectionMode.NONE;
        this.selectedContactsAll = [];
        this.selectedContactGroups = [];
        this.selectedContactsNoGroup = [];
        this.$('.other-actions, .proqual-screening, .btn-merge').prop('disabled', false);
        this.$('.updater-continue, .updater-cancel').hide();
        this.hideNotification();
        this.renderView();
    }
});

// Modals
PJQ.views.addressbook.FilterTradesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Filter-Trades'),
        minWidth: '800px',
        directoryFilter: -1 * PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY,
        selectedGroups: []
    },
    events: {
        'click button.clear-all': 'clearAll',
        'click button.filter': 'filter'
    },
    afterRender: function () {
        let hasGroupsLinked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED),
            showPublic = false, showPrivate = false;

        switch (this.options.directoryFilter * -1) {
            case PJQ.constants.addressBook.directoryFilter.ALL_CONTACTS:
                showPrivate = true;
                showPublic = !hasGroupsLinked;
                break;
            case PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY:
                showPrivate = true;
                showPublic = false;
                break;
            case PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY:
                showPrivate = hasGroupsLinked;
                showPublic = !hasGroupsLinked;
                break;
        }

        if (!showPrivate) {
            this.$('.filter-groups').hide();
            this.$('.filter-groups-public').show();
        }

        if (!showPublic || !showPrivate)
            this.$('.trade-type').hide();

        if (showPrivate && showPublic) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.trade-type'),
                isIntChoices: true,
                defaultValue: 0,
                onChange: _.bind(function (value) {
                    if (value === 0) {
                        this.$('.filter-groups').show();
                        this.$('.filter-groups-public').hide();
                    } else {
                        this.$('.filter-groups').hide();
                        this.$('.filter-groups-public').show();
                    }
                }, this)
            });
        }

        if (showPrivate) {
            this.groupSelector = new PJQ.views.groups.GroupSelector({
                el: this.$('.filter-groups'),
                isShowNoGroup: true,
                selectedGroupIds: this.options.selectedGroups
            });
        }

        if (showPublic) {
            this.groupSelectorPublic = new PJQ.views.groups.GroupSelector({
                el: this.$('.filter-groups-public'),
                isShowNoGroup: false,
                isPublicGroups: true,
                selectedGroupIds: this.options.selectedGroups
            });
        }
    },
    clearAll: function () {
        if (this.groupSelector)
            this.groupSelector.selectAll(false);
        if (this.groupSelectorPublic)
            this.groupSelectorPublic.selectAll(false);

    },
    filter: function () {
        let groups = [];

        if (this.groupSelector)
            groups = _.union(groups, _.map(this.groupSelector.getGroupsData().selected, function (group) {
                return group.get('groupId');
            }));

        if (this.groupSelectorPublic)
            groups = _.union(groups, _.map(this.groupSelectorPublic.getGroupsData().selected, function (group) {
                return group.get('groupId');
            }));

        if (typeof this.options.onFilter === 'function')
            this.options.onFilter(groups);

        this.removeModal();
    }
});

PJQ.views.addressbook.AddressBookSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'modal-addressbook-settings'),
        width: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.model = this.options.addressBookView.settings;
    },
    beforeRender: function () {
        // copy settings for our UI; we only update global settings object on save.
        this.options.settings = [];
        this.options.defaultView = this.model.get('defaultView');
        _.each(this.model.attributes.settings, _.bind(function (setting) {
            if (setting.view === PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP ||
                setting.view === PJQ.constants.addressBook.view.TRADES_CONTACT_GROUP)
                return;

            let columns = this.options.addressBookView.getDataTableInstance({
                    view: setting.view,
                    settings: this.model.getSettings(setting.view)
                }).getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.settings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns,
                showGroupDescription: setting.showGroupDescription
            });
        }, this));
    },
    renderData: function () {
        return {
            model: this.model,
            showGroupCompanyView: true, // todo: read from preferences
            showGroupContactView: true // todo: read from preferences
        }
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view-default'),
            defaultValue: this.options.defaultView,
            onChange: _.bind(function (value) {
                this.options.defaultView = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view'),
            defaultValue: this.options.addressBookView.dataTable.options.view,
            onChange: _.bind(function (value) {
                this.selectView(value);
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)

        });

        this.$('input.show-group-description').change(_.bind(function () {
            this.currentView.showGroupDescription = this.$('input.show-group-description').prop('checked');
        }, this));

        this.selectView(this.options.addressBookView.dataTable.options.view);
    },
    editCompanySettings: function () {
        this.model = new PJQ.models.addressBook.AddressBookViewSettings(null, {
            forCompany: true
        });
        this.model.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.settings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.$('div.rows-per-page').show();
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
        } else
            this.$('div.rows-per-page').hide();

        if (view === PJQ.constants.addressBook.view.TRADES_COMPANY || view === PJQ.constants.addressBook.view.TRADES_CONTACT) {
            this.$('div.show-group-description').show();
            this.$('input.show-group-description').prop('checked', this.currentView.showGroupDescription);
            this.$('div.select-columns').hide();
        } else {
            this.$('div.show-group-description').hide();
            this.$('div.select-columns').show();

            if (this.dataTable) {
                this.dataTable.undelegateEvents();
                $(this.dataTable.el).empty();
            }

            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$('div.select-columns-datatable'),
                data: this.currentView.columns,
                isHideSearch: true,
                order: [],
                columns: [
                    {"data": "title", "title": "Column", "orderable": false},
                    {
                        "data": "visible",
                        "title": "Show",
                        "orderable": false,
                        "searchable": false,
                        "render": _.bind(function (data) {
                            return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                        }, this),
                        "width": '10%'
                    }
                ],
                dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
            });
        }
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let forCompany = this.model.get('userId') === PJQ.app.session.get('masterUserId'),
            fnOnSave = _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave();
                this.removeModal();
            }, this);

        this.model.set('defaultView', this.options.defaultView);

        _.each(this.options.settings, _.bind(function (settingTemp) {
            _.each(this.model.get('settings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;
                    setting.showGroupDescription = settingTemp.showGroupDescription;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    if (setting.view === PJQ.constants.addressBook.view.TRADES_COMPANY ||
                        setting.view === PJQ.constants.addressBook.view.TRADES_CONTACT) {

                        columns = setting.showGroupDescription ? ['groupDescription', 'groupCount', 'childCount'] : ['groupName', 'childCount'];
                    } else {
                        _.each(settingTemp.columns, _.bind(function (column) {
                            if (column.visible) {
                                if (columns.indexOf(column.columnData) === -1)
                                    columns.push(column.columnData);
                            } else {
                                if (columns.indexOf(column.columnData) !== -1)
                                    columns = _.filter(columns, _.bind(function (columnTemp) {
                                        return columnTemp != column.columnData;
                                    }, this));
                            }
                        }, this));
                    }

                    setting.columns = columns;
                }
            }, this));
        }, this));

        //save settings to database
        this.model.save(null, {
            success: _.bind(function () {
                if (forCompany) {
                    this.options.addressBookView.settings.fetch({
                        success: _.bind(function () {
                            fnOnSave();
                        }, this)
                    })
                } else {
                    this.model.set('defaultView', this.options.defaultView);
                    fnOnSave();
                }
            }, this)
        });
    }
});

PJQ.views.addressbook.AdvancedSearchModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'modal-advanced-search'),
        maxWidth: '70%',
        onSearch: _.noop,
        minWidth: 800
    },
    events: {
        'click .clear-search': 'clearSearch',
        'click .save-search': 'saveSearch',
        'click .delete-search': 'deleteSearch',
        'click .default-search': 'defaultSearch',
        'click .search': 'search',
        'keydown .phone': 'numbersOnly',
        'keydown .phone-ext': 'numbersOnly',
        'keydown .fax': 'numbersOnly',
        'keydown .cell': 'numbersOnly'
    },
    beforeModalCreated: function () {
        this.options.fieldSettingsEnabled = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
        if (this.options.fieldSettingsEnabled && this.coreFieldSettings == null) {
            PJQ.app.session.fetchContactFieldSettings(this.options.masterUserId, _.bind(function (settings) {
                this.coreFieldSettings = settings;
                this.render();
            }, this));
        }
    },
    beforeRender: function () {
        this.renderData = {
            searches: this.options.settings.get('searches'),
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            fieldSettingsEnabled: this.options.fieldSettingsEnabled,
            coreFieldSettings: this.coreFieldSettings
        };
    },
    afterRender: function () {
        if (this.options.fieldSettingsEnabled && this.coreFieldSettings == null) {
            return;
        }

        this.savedSearchSelectPicker = new PJQ.inputs.Selectpicker({
            el: $('.saved-search'),
            noneSelectedText: 'New Search',
            defaultValue: null,
            onChange: _.bind(function () {
                let advancedSearch = _.filter(this.options.settings.get('searches'), _.bind(function (savedSearch) {
                    return savedSearch.searchId === this.savedSearchSelectPicker.getValue();
                }, this))[0];
                this.$('.delete-search, .default-search').prop('disabled', false);
                this.setInputsFromSearch(advancedSearch);
            }, this)
        });

        if (_.size(this.options.settings.get('searches')) > 0)
            this.savedSearchSelectPicker.enable();

        this.companyBlacklistSelectPicker = new PJQ.inputs.Selectpicker({
            el: $('.company-is-blacklisted'),
            isIntChoices: true,
            defaultValue: 0,
            onChange: _.bind(function () {
            }, this)
        });

        if (this.checkFieldVisible('laborStatus')) {
            this.laborSelectPicker = new PJQ.inputs.Selectpicker({
                el: $('.labor-status'),
                isMultiple: true,
                onChange: _.bind(function () {
                }, this)
            });
        }

        if (this.checkFieldVisible('classifications')) {
            this.classificationSelectPicker = new PJQ.inputs.Selectpicker({
                el: $('.minority-status'),
                isMultiple: true,
                onChange: _.bind(function () {
                }, this)
            });
        }

        if (this.checkFieldVisible('sector')) {
            this.sectorSelectPicker = new PJQ.inputs.Selectpicker({
                el: $('.sector'),
                isMultiple: true,
                onChange: _.bind(function () {
                }, this)
            });
        }

        this.gradeSlider = new PJQ.Slider(this.$('.grade-slider'), {
            ticks: [0, 1, 2, 3, 4, 5],
            ticks_labels: [0, 1, 2, 3, 4, 5],
            value: [0, 5],
            onChange: _.bind(function (value) {
            }, this)
        });

        this.companyCustomFieldsCollapse = new PJQ.views.collapse.BaseCollapse({
            el: this.$('#advancedSearchCompanyCustomFieldsCollapseContainer')
        });

        PJQ.app.session.fetchCompanyCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function (customFields) {
            this.companyCustomFields = customFields;
            this.companyCustomFieldsForm = new PJQ.views.customFields.CustomFieldsSearchForm({
                el: this.$('.advanced-search-company-custom-fields'),
                isAdmin: true,
                collection: this.companyCustomFields,
                fieldValues: null
            });
        }, this));

        this.contactBlacklistSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.contact-is-blacklisted'),
            isMultiple: false,
            isIntChoices: true,
            defaultValue: 0,
            onChange: _.bind(function () {
            }, this)
        });

        this.contactTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.contact-type'),
            isMultiple: true,
            isIntChoices: true,
            defaultValue: null,
            onChange: _.bind(function () {
            }, this)
        });

        this.contactPrimarySelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.contact-is-primary'),
            isMultiple: false,
            isIntChoices: true,
            defaultValue: 0,
            onChange: _.bind(function () {
            }, this)
        });

        this.locationSearchTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.location-search-type'),
            isIntChoices: true,
            defaultValue: 0,
            onChange: _.bind(function () {
                this.locationSearchTypeChanged();
            }, this)
        });
        this.locationSearchTypeChanged();

        this.locationTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.location-type'),
            isIntChoices: true,
            isMultiple: true,
            defaultValue: 1,
            onChange: _.bind(function (value) {
                let $radius = this.$('.search-radius-outer');
                if (value && value.indexOf(2) === -1) {
                    $radius.hide();
                } else {
                    $radius.show();
                }
            }, this)
        });

        this.searchRadiusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.search-radius'),
            isIntChoices: true,
            defaultValue: 0
        });

        this.$('.cross-state-bounds').prop('checked', true);

        this.stateSelectPicker = new PJQ.inputs.StatePicker({
            el: this.$('select.state'),
            country: 'US',
            defaultValue: null,
            onChange: _.bind(function (value) {
            }, this)
        });

        this.countrySelectPicker = new PJQ.inputs.CountryPicker({
            el: this.$('select.country'),
            defaultValue: 'US',
            statePicker: this.stateSelectPicker,
            zipInput: this.$('.zip-2'),
            onChange: _.bind(function (value) {
            }, this)
        });

        this.groupCollapseContainer = new PJQ.views.collapse.BaseCollapse({
            el: this.$('#advancedSearchGroupsCollapseContainer')
        });

        this.groupSelector = new PJQ.views.groups.GroupSelector({
            el: this.$('.advanced-search-groups'),
            isShowNoGroup: true,
            onGroupSelected: _.bind(function () {
                //todo: trigger dirty
            }, this)
        });

        new PJQ.views.collapse.BaseCollapse({
            el: this.$('#advancedSearchContactCustomFieldsCollapseContainer')
        });

        PJQ.app.session.fetchContactCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function (customFields) {
            this.contactCustomFields = customFields;
            this.contactCustomFieldsForm = new PJQ.views.customFields.CustomFieldsSearchForm({
                el: this.$('.advanced-search-contact-custom-fields'),
                isAdmin: true,
                collection: this.contactCustomFields,
                fieldValues: null
            });
        }, this));

        if (this.options.advancedSearch)
            this.setInputsFromSearch(this.options.advancedSearch);
        else {
            _.each(this.options.settings.get('searches'), _.bind(function (savedSearch) {
                if (savedSearch.isDefault)
                    this.setInputsFromSearch(savedSearch);
            }, this))
        }
    },
    locationSearchTypeChanged: function () {
        if (this.locationSearchTypeSelectPicker.getValue() === 0) {
            this.$('.location-search-zip-radius').removeClass('hidden');
            this.$('.location-search-city-state-zip').addClass('hidden');
        } else {
            this.$('.location-search-zip-radius').addClass('hidden');
            this.$('.location-search-city-state-zip').removeClass('hidden');
        }
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            let result;
            switch (fieldName) {
                case 'sector':
                    result = !prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_SECTOR);
                    break;
                case 'laborStatus':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
                    break;
                case 'classifications':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_MINORITY_STATUS) === false;
                    break;
                default:
                    result = true;
            }
            return result;
        } else {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisibleContact') || fieldSettings.get('isVisibleAdmin');
            }
        }
        return true;
    },
    setInputsFromSearch: function (advancedSearch) {
        let search = _.filter(this.options.settings.get('searches'), _.bind(function (savedSearch) {
            return savedSearch.searchId === advancedSearch.searchId;
        }, this));

        if (_.size(search) > 0) {
            this.savedSearchSelectPicker.setValue(advancedSearch.searchId);
            this.$('.delete-search, .default-search').prop('disabled', false);
            this.$('.default-search').text(advancedSearch.isDefault ? 'Unset Default' : 'Set Default');
        } else {
            this.savedSearchSelectPicker.setValue(null);
            this.$('.delete-search, .default-search').prop('disabled', true);
            this.$('.default-search').text('Set Default');
        }

        this.$('input.search-name').val(advancedSearch.searchName);
        this.$('input.company-name').val(advancedSearch.companyName);
        this.companyBlacklistSelectPicker.setValue(advancedSearch.isCompanyBlacklisted ? 1 : 0);

        if (this.laborSelectPicker != null) {
            let laborStatus = [];
            if (advancedSearch.isUnion)
                laborStatus.push('isUnion');
            if (advancedSearch.isNonUnion)
                laborStatus.push('isNonUnion');
            if (advancedSearch.isPrevailingWage)
                laborStatus.push('isPrevailingWage');
            this.laborSelectPicker.setValue(laborStatus);
        }

        if (this.classificationSelectPicker != null) {
            let classification = [];
            if (advancedSearch.isDBE)
                classification.push('isDBE');
            if (advancedSearch.isDVBE)
                classification.push('isDVBE');
            if (advancedSearch.isMBE)
                classification.push('isMBE');
            if (advancedSearch.isSBE)
                classification.push('isSBE');
            if (advancedSearch.isSDVBE)
                classification.push('isSDVBE');
            if (advancedSearch.isWBE)
                classification.push('isWBE');
            this.classificationSelectPicker.setValue(classification);
        }

        if (this.sectorSelectPicker != null) {
            let sector = [];
            if (advancedSearch.isPrivateSector)
                sector.push('isPrivateSector');
            if (advancedSearch.isPublicSector)
                sector.push('isPublicSector');
            this.sectorSelectPicker.setValue(sector);
        }

        this.gradeSlider.setValue([advancedSearch.minGradeAverage, advancedSearch.maxGradeAverage]);

        this.companyCustomFieldsForm.setValues(advancedSearch.companyCustomFields);
        if (_.size(advancedSearch.companyCustomFields) > 0)
            this.$('#advancedSearchCompanyCustomFieldsCollapse').collapse('show');

        this.$('input.contact-name').val(advancedSearch.contactName);
        this.$('input.contact-title').val(advancedSearch.contactTitle);
        this.contactBlacklistSelectPicker.setValue(advancedSearch.isBlacklisted ? 1 : 0);

        this.$('input.phone').val(advancedSearch.phone);
        this.$('input.phone-ext').val(advancedSearch.phoneExtension);
        this.$('input.fax').val(advancedSearch.fax);
        this.$('input.cell').val(advancedSearch.cell);
        this.contactTypeSelectPicker.setValue(advancedSearch.userTypes);
        this.contactPrimarySelectPicker.setValue(advancedSearch.isPrimaryOnly ? 1 : 0);

        this.$('input.email').val(advancedSearch.email);

        if (advancedSearch.locationType > 0) {
            this.locationSearchTypeSelectPicker.setValue(0);
            this.$('.location-search-zip-radius').removeClass('hidden');
            this.$('.location-search-city-state-zip').addClass('hidden');

            let locationFilter;
            if (advancedSearch.locationType === 3) {
                locationFilter = [1, 2];
            } else {
                locationFilter = [advancedSearch.locationType];
            }
            this.locationTypeSelectPicker.setValue(locationFilter);
            this.locationTypeSelectPicker.options.onChange(locationFilter);

            this.$('input.zip-1').val(advancedSearch.originzip);
            this.searchRadiusSelectPicker.setValue(advancedSearch.radius);
            this.$('.cross-state-bounds').prop('checked', advancedSearch.isCrossStateBoundaries);
            this.$('input.city').val('');
            this.stateSelectPicker.setValue(null);
            this.$('input.zip-2').val('');
            this.countrySelectPicker.setValue('US');
        } else {
            this.locationSearchTypeSelectPicker.setValue(1);
            this.$('.location-search-zip-radius').addClass('hidden');
            this.$('.location-search-city-state-zip').removeClass('hidden');

            let locationFilter = [0];
            this.locationTypeSelectPicker.setValue(locationFilter);
            this.locationTypeSelectPicker.options.onChange(locationFilter);

            this.locationTypeSelectPicker.options.onChange();
            this.$('input.zip-1').val('');
            this.searchRadiusSelectPicker.setValue(0);
            this.$('.cross-state-bounds').prop('checked', true);
            this.$('input.city').val(advancedSearch.city);
            this.stateSelectPicker.setValue(advancedSearch.state);
            this.$('input.zip-2').val(advancedSearch.zip);
            this.countrySelectPicker.setValue(advancedSearch.country);
        }

        if (this.groupSelector.collection)
            this.groupSelector.selectAll(false);
        this.groupSelector.selectGroups(advancedSearch.groups);
        this.groupSelector.expandSelectedParents();
        if (_.size(advancedSearch.groups) > 0)
            this.$('#advancedSearchGroupsCollapse').collapse('show');

        this.contactCustomFieldsForm.setValues(advancedSearch.customFields);
        if (_.size(advancedSearch.customFields) > 0)
            this.$('#advancedSearchContactCustomFieldsCollapse').collapse('show');
    },
    createSearchFromInputs: function () {
        let advancedSearch = this.savedSearchSelectPicker.getValue() ? _.filter(this.options.settings.get('searches'), _.bind(function (savedSearch) {
            return savedSearch.searchId === this.savedSearchSelectPicker.getValue();
        }, this))[0] : {};

        advancedSearch.searchId = this.savedSearchSelectPicker.getValue() ? this.savedSearchSelectPicker.getValue() : PJQ.helpers.guid();
        advancedSearch.searchName = this.$('input.search-name').val().trim();
        advancedSearch.companyName = this.$('input.company-name').val().trim();
        advancedSearch.isCompanyBlacklisted = this.companyBlacklistSelectPicker.getValue() === 1;

        if (this.laborSelectPicker != null) {
            advancedSearch.isUnion = this.laborSelectPicker.getValue().indexOf('isUnion') !== -1;
            advancedSearch.isNonUnion = this.laborSelectPicker.getValue().indexOf('isNonUnion') !== -1;
            advancedSearch.isPrevailingWage = this.laborSelectPicker.getValue().indexOf('isPrevailingWage') !== -1;
        }

        if (this.classificationSelectPicker != null) {
            advancedSearch.isDBE = this.classificationSelectPicker.getValue().indexOf('isDBE') !== -1;
            advancedSearch.isDVBE = this.classificationSelectPicker.getValue().indexOf('isDVBE') !== -1;
            advancedSearch.isMBE = this.classificationSelectPicker.getValue().indexOf('isMBE') !== -1;
            advancedSearch.isSBE = this.classificationSelectPicker.getValue().indexOf('isSBE') !== -1;
            advancedSearch.isSDVBE = this.classificationSelectPicker.getValue().indexOf('isSDVBE') !== -1;
            advancedSearch.isWBE = this.classificationSelectPicker.getValue().indexOf('isWBE') !== -1;
        }

        if (this.sectorSelectPicker != null) {
            advancedSearch.isPrivateSector = this.sectorSelectPicker.getValue().indexOf('isPrivateSector') !== -1;
            advancedSearch.isPublicSector = this.sectorSelectPicker.getValue().indexOf('isPublicSector') !== -1;
        }

        advancedSearch.minGradeAverage = this.gradeSlider.getValue()[0];
        advancedSearch.maxGradeAverage = this.gradeSlider.getValue()[1];

        advancedSearch.companyCustomFields = this.companyCustomFieldsForm.getValues();

        advancedSearch.contactName = this.$('input.contact-name').val().trim();
        advancedSearch.contactTitle = this.$('input.contact-title').val().trim();
        advancedSearch.isBlacklisted = this.contactBlacklistSelectPicker.getValue() === 1;

        advancedSearch.phone = this.$('input.phone').val().trim();
        advancedSearch.phoneExtension = this.$('input.phone-ext').val().trim();
        advancedSearch.fax = this.$('input.fax').val().trim();
        advancedSearch.cell = this.$('input.cell').val().trim();
        advancedSearch.userTypes = this.contactTypeSelectPicker.getValue();
        advancedSearch.isPrimaryOnly = this.contactPrimarySelectPicker.getValue() === 1;

        advancedSearch.email = this.$('input.email').val().trim();

        if (this.locationSearchTypeSelectPicker.getValue() === 0) {
            let loc = this.locationTypeSelectPicker.getValue(),
                isWorkAreas = loc.indexOf(1) !== -1,
                isOffice = loc.indexOf(2) !== -1,
                locationFilter;
            if (isWorkAreas && isOffice) {
                locationFilter = 3;
            } else if (isWorkAreas) {
                locationFilter = 1;
            } else if (isOffice) {
                locationFilter = 2;
            }
            advancedSearch.locationType = locationFilter;
            advancedSearch.originzip = this.$('input.zip-1').val().trim();
            advancedSearch.radius = this.searchRadiusSelectPicker.getValue();
            advancedSearch.isCrossStateBoundaries = this.$('.cross-state-bounds').prop('checked');
            advancedSearch.city = '';
            advancedSearch.state = '';
            advancedSearch.zip = '';
            advancedSearch.country = '';
        } else {
            advancedSearch.locationType = 0;
            advancedSearch.originzip = '';
            advancedSearch.radius = 0;
            advancedSearch.isCrossStateBoundaries = true;
            advancedSearch.city = this.$('input.city').val().trim();
            advancedSearch.state = this.stateSelectPicker.getValue();
            advancedSearch.zip = this.$('input.zip-2').val().trim();
            advancedSearch.country = this.countrySelectPicker.getValue();
        }

        advancedSearch.groups = _.map(this.groupSelector.getGroupsData().selected, function (group) {
            return group.get('groupId');
        });
        advancedSearch.regions = [];

        advancedSearch.customFields = this.contactCustomFieldsForm.getValues();

        return advancedSearch;
    },
    validate: function (save) {
        let isValid = true;

        if (!this.companyCustomFieldsForm.validateSearch()) {
            isValid = false;
            this.$('#advancedSearchCompanyCustomFieldsCollapse').collapse('show');
        }

        if (!this.contactCustomFieldsForm.validateSearch()) {
            isValid = false;
            this.$('#advancedSearchContactCustomFieldsCollapse').collapse('show');
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('input.search-name'), true);
        if (save && _.size(this.$('input.search-name').val().trim()) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('input.search-name'), false);
        }

        return isValid;
    },
    saveSearch: function () {
        this.search(null, true);
    },
    search: function (e, save) {
        let advancedSearch = this.createSearchFromInputs(), callback = _.bind(function () {
            this.options.onSearch(advancedSearch);
            this.removeModal();
        }, this);

        if (!this.validate(save))
            return;

        if (save) {
            if (this.savedSearchSelectPicker.getValue()) {
                _.each(this.options.settings.get('searches'), _.bind(function (search) {
                    if (search.searchId === advancedSearch.searchId)
                        search = advancedSearch;
                }, this));
            } else {
                this.options.settings.get('searches').push(advancedSearch);
            }
            this.options.settings.save(null, {
                success: _.bind(function () {
                    callback();
                }, this)
            });
        } else {
            callback();
        }
    },
    clearSearch: function () {
        this.options.advancedSearch = null;
        this.$('.delete-search, .default-search').prop('disabled', true);
        this.$('.default-search').text('Set Default');

        this.savedSearchSelectPicker.setValue(null);
        this.$('.search-name').val('');

        this.$('.company-name').val('');
        this.companyBlacklistSelectPicker.setValue(0);

        if (this.laborSelectPicker != null) {
            this.laborSelectPicker.setValue(null);
        }
        if (this.classificationSelectPicker != null) {
            this.classificationSelectPicker.setValue(null);
        }
        if (this.sectorSelectPicker != null) {
            this.sectorSelectPicker.setValue(null);
        }

        this.gradeSlider.setValue([0, 5]);

        this.companyCustomFieldsForm.clearFieldValues();
        this.$('#advancedSearchCompanyCustomFieldsCollapse').collapse('hide');

        this.$('.contact-name,.phone,.phone-ext,.fax,.cell,.email').val('');
        this.contactBlacklistSelectPicker.setValue(0);

        this.groupSelector.selectAll(false);
        this.$('#advancedSearchGroupsCollapse').collapse('hide');

        this.contactCustomFieldsForm.clearFieldValues();
        this.$('#advancedSearchContactCustomFieldsCollapse').collapse('hide');

        this.locationSearchTypeSelectPicker.setValue(0);
        this.locationTypeSelectPicker.setValue(1);
        this.$('.zip-1, .zip-2, .city').val('');
        this.countrySelectPicker.setValue('US');
        this.stateSelectPicker.setValue(null);
        this.searchRadiusSelectPicker.setValue(0);
        this.$('.cross-state-bounds').prop('checked', true);
        this.locationSearchTypeChanged();

        this.$('.company-name').focus();
    },
    deleteSearch: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this search?",
            onDelete: _.bind(function () {
                this.options.settings.set('searches', _.filter(this.options.settings.get('searches'), _.bind(function (search) {
                    return (search.searchId !== this.savedSearchSelectPicker.getValue());
                }, this)));

                this.options.settings.save(null, {
                    success: _.bind(function () {
                        this.$('select.saved-search option[value="' + this.savedSearchSelectPicker.getValue() + '"]').remove();
                        this.savedSearchSelectPicker.setValue(null);
                        this.savedSearchSelectPicker.refresh();
                        this.clearSearch();
                    }, this)
                });
            }, this)
        });
    },
    defaultSearch: function () {
        // find current search
        let search = _.filter(this.options.settings.get('searches'), _.bind(function (savedSearch) {
            return savedSearch.searchId === this.savedSearchSelectPicker.getValue();
        }, this))[0];

        if (!this.validate(true))
            return;

        // toggle search state / button label
        if (search.isDefault) {
            search.isDefault = false;
        } else {
            _.each(this.options.settings.get('searches'), _.bind(function (savedSearch) {
                savedSearch.isDefault = (savedSearch.searchId === search.searchId);
            }, this));
        }

        // save
        this.options.settings.save(null, {
            success: _.bind(function () {
                this.$('.default-search').text(search.isDefault ? 'Unset Default' : 'Set Default');
                PJQ.notifications.notify.successNotify({
                    message: 'Default search ' + (search.isDefault ? 'saved' : 'cleared') + ' successfully'
                });
            }, this)
        });
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e);
    }
});

PJQ.views.addressbook.ProqualRequestModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Proqual-Request'),
        minWidth: '800px',
        request: {
            screeningPackageId: null,
            isBillSender: null,
            processorNotes: '',
            uploaderGuid: PJQ.helpers.guid(),
            attachments: new PJQ.collections.files.Files(),
            selectedContacts: []
        },
        onAddParticipants: _.noop,
        onSend: _.noop
    },
    events: {
        'click .add-contacts': 'addContacts',
        'click .request-close': 'close',
        'click .request-preview': 'previewRequest',
        'click .request-viewitems': 'viewPackageItems',
        'click .request-send': 'sendRequest',
        'change .proqual-notes': 'notesChanged'
    },
    beforeModalCreated: function () {
        this.options.isProqual = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_CUSTOMER);
        this.options.isSingleContact = this.options.contactId > 0;
        if (this.options.isSingleContact) {
            this.options.isSingleContact = true;
            this.options.request.selectedContacts = [this.options.contactId];
        }

        PJQ.app.session.fetchScreeningSettings(_.bind(function (settings) {
            this.settings = settings;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            selectedContacts: this.options.request.selectedContacts,
            settings: this.settings.attributes,
            isProqual: this.options.isProqual,
            isSingleContact: this.options.isSingleContact,
        };
    },
    setButtonStates: function () {
        this.$('.request-preview, .request-viewitems').prop('disabled', !this.packageSelectPicker.getValue());
        this.$('.request-send').prop('disabled', !this.packageSelectPicker.getValue() || (this.paymentSelectPicker != null && !this.paymentSelectPicker.getValue()) || (_.size(this.options.request.selectedContacts) === 0 && _.size(this.options.request.attachments) === 0));
    },
    afterRender: function () {
        if (this.settings == null)
            return;

        this.packageSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.proqual-package'),
            noneSelectedText: 'Select Package',
            isIntChoices: true,
            defaultValue: this.options.request.screeningPackageId,
            onChange: _.bind(function (value) {
                this.options.request.screeningPackageId = value;
                this.setButtonStates();
            }, this)
        });

        if (this.options.isProqual) {
            this.$('.proqual-payment').prop('disabled', this.settings.get('isPaymentMethodReadOnly'));
            if (this.options.request.isBillSender == null && this.settings.get('defaultPaymentMethod') != null) {
                this.options.request.isBillSender = this.settings.get('defaultPaymentMethod').toLowerCase() === 'sender';
            }

            this.paymentSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.proqual-payment'),
                noneSelectedText: 'Select Payment Type',
                isIntChoices: true,
                defaultValue: this.options.request.isBillSender !== undefined ? (this.options.request.isBillSender ? 1 : 2) : null,
                onChange: _.bind(function (value) {
                    if (value !== null)
                        this.options.request.isBillSender = (value === 1);

                    this.setButtonStates();
                }, this)
            });

            this.$('.proqual-notes').val(this.options.request.processorNotes ? this.options.request.processorNotes : '');

            if (!this.options.isSingleContact) {
                this.uploader = new PJQ.views.files.FileUploaderGrid({
                    el: this.$('.request-uploader'),
                    collection: this.options.request.attachments,
                    uuid: this.options.request.uploaderGuid,
                    onDelete: _.bind(function (attachment, callback) {
                        attachment.destroy();
                        callback();
                        this.setButtonStates();
                    }, this),
                    onSuccess: _.bind(function () {
                        this.setButtonStates();
                    }, this),
                });
            }
        }

        this.setButtonStates();
    },
    notesChanged: function () {
        this.options.request.processorNotes = this.$('.proqual-notes').val();
    },
    addContacts: function () {
        if (this.uploader) {
            this.options.request.attachments = this.uploader.collection;
        }
        this.options.onAddParticipants(this.options.request);
        this.removeModal();
    },
    previewRequest: function () {
        new PJQ.views.addressbook.ProqualRequestPreviewModal({
            screeningPackageId: this.packageSelectPicker.getValue()
        });
    },
    viewPackageItems: function () {
        new PJQ.views.addressbook.ProqualRequestViewItemsModal({
            screeningPackage: _.filter(this.settings.get('packages'), _.bind(function (screeningPackage) {
                return screeningPackage.screeningPackageId === this.packageSelectPicker.getValue();
            }, this))[0]
        });
    },
    sendRequest: function () {
        let confirmText;
        if (this.options.isProqual) {
            confirmText = "Are you sure you want to " + (this.paymentSelectPicker.getValue() === 1 ? "place this order and " : "") + "send these requests?";
        } else {
            confirmText = "Are you sure you want to send this request?";
        }
        let callback = _.bind(function () {
            new PJQ.views.modals.YesNo({
                header: "Confirm Request",
                body: confirmText,
                onYes: _.bind(function () {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'addressbook'
                            },
                            {
                                endpoint: 'proqual'
                            },
                            {
                                endpoint: 'request'
                            }
                        ]),
                        data: {
                            screeningPackageId: this.packageSelectPicker.getValue(),
                            isBillSender: this.options.request.isBillSender,
                            notes: this.options.request.processorNotes,
                            attachments: this.options.request.attachments.models,
                            contacts: this.options.request.selectedContacts
                        }
                    }).post().done(_.bind(function (data) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Your qualification request is now queued for processing.'
                        });
                        this.options.onSend();
                        this.removeModal();
                    }, this)).fail(function () {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Something went wrong.'
                        });
                    });
                }, this)
            });
        }, this);

        if (_.size(this.options.request.selectedContacts) > 0) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'addressbook'
                    },
                    {
                        endpoint: 'proqual'
                    },
                    {
                        endpoint: 'request'
                    },
                    {
                        endpoint: 'check'
                    }
                ]),
                data: {
                    screeningPackageId: this.options.request.screeningPackageId,
                    contacts: this.options.request.selectedContacts
                }
            }).post().done(_.bind(function (data) {
                if (_.size(data.contacts) > 0) {
                    new PJQ.views.addressbook.ProqualRequestErrorModal({
                        contacts: data.contacts,
                        selectedContacts: this.options.request.selectedContacts,
                        onContinue: _.bind(function () {
                            callback();
                        }, this)
                    });
                } else
                    callback();
            }, this)).fail(function () {
                PJQ.notifications.notify.errorNotify({
                    message: 'Something went wrong.'
                });
            });
        } else {
            callback();
        }
    }
});

PJQ.views.addressbook.ProqualRequestViewItemsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Proqual-Request-Items'),
        minWidth: '60%',
        screeningPackage: null
    },
    beforeRender: function () {
        this.renderData = {
            items: this.options.screeningPackage.packageItems
        };
    }
});

PJQ.views.addressbook.ProqualRequestPreviewModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Proqual-Request-Preview'),
        minWidth: '60%',
        screeningPackageId: 0
    },
    events: {
        'click .preview-export': 'export'
    },
    beforeModalCreated: function () {
        this.isFetched = false;

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'addressbook',
            },
            {
                endpoint: 'proqual'
            },
            {
                endpoint: 'preview'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                screeningPackageId: this.options.screeningPackageId,
                isExport: false
            }
        }).post().done(_.bind(function (data) {
            this.isFetched = true;
            this.previewHTML = data.html;
            this.render();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    afterRender: function () {
        this.$('.message-body').html(this.previewHTML);
    },
    export: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'addressbook',
            },
            {
                endpoint: 'proqual'
            },
            {
                endpoint: 'preview'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                screeningPackageId: this.options.screeningPackageId,
                isExport: true
            }
        }).post().done(_.bind(function (data) {
            PJQ.files.downloadFile(data.url, {isEndpoint: false});
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    }
});

PJQ.views.addressbook.ProqualRequestErrorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Proqual-Request-Error-List'),
        minWidth: '90%',
        contacts: null,
        selectedContacts: null,
        onContinue: _.noop
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-continue': 'continue',
        'click .export': 'export'
    },
    beforeRender: function () {
        this.renderData = {
            invalidContacts: _.size(this.options.contacts),
            validContacts: _.size(this.options.selectedContacts) - _.size(this.options.contacts)
        };
    },
    afterRender: function () {
        new PJQ.views.dataTables.DataTable({
            el: this.$('.contact-errors'),
            pageLength: 999999,
            isHideSearch: true,
            data: this.options.contacts,
            dom: 't',
            order: [],
            columns: [
                {
                    "data": "companyName",
                    "title": "Company",
                    "orderable": false
                },
                {
                    "data": "contactName",
                    "title": "Contact",
                    "orderable": false
                },
                {
                    "data": "phone",
                    "title": "Phone",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                            phoneFormatted = row.phone ? (PJQ.helpers.formatHelpers.formatPhoneNumber(row.phone) + (_.size(row.phoneExtension) === 0 ? '' : ' x' + row.phoneExtension)) : 'N/A';

                        if (row.phone !== '')
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                        html += '<div class="flex-fill ' + (row.phone ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                        html += '</div>';
                        return html;
                    }, this)
                },
                {
                    "data": "email",
                    "title": "Email",
                    "orderable": false
                },
                {
                    "data": "reason",
                    "title": "Reason",
                    "orderable": false
                }
            ]
        });

    },
    continue: function () {
        if (typeof this.options.onContinue === 'function')
            this.options.onContinue();

        this.removeModal();
    },
    export: function () {
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    }
});

PJQ.views.addressbook.MergeRequestModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Merge-Request'),
        minWidth: '70%',
        data: null,
        addressBookView: null,
        onMerge: _.noop
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-merge-confirm': 'mergeContacts'
    },
    beforeModalCreated: function () {
        this.companies = [];
        this.contacts = [];

        _.each(this.options.data, _.bind(function (item) {

            if (!item.company.companyName) {
                item.company.companyName = 'Company ' + item.company.contactId.toString();
                _.each(item.contacts, function (contact) {
                    contact.companyName = item.company.companyName;
                });
            }

            this.companies.push(item.company);
            $.merge(this.contacts, item.contacts);
        }, this));
    },
    beforeRender: function () {
        this.renderData = {
            companies: this.companies
        };
    },
    afterRender: function () {
        this.destinationSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.destination-company'),
            defaultValue: null,
            onChange: _.bind(function (value) {
                this.$('.btn-merge-confirm').prop('disabled', !value);
            }, this)
        });

        new PJQ.views.dataTables.DataTable({
            el: this.$('.merge-data'),
            pageLength: 999999,
            isHideSearch: true,
            data: this.contacts,
            dom: 't',
            order: [],
            columns: [
                {
                    "data": "companyName",
                    "title": "Company",
                    "orderable": false
                },
                {
                    "data": "contactName",
                    "title": "Contact",
                    "orderable": false
                },
                {
                    "data": "phone",
                    "title": "Phone",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                            phoneFormatted = row.phone ? (PJQ.helpers.formatHelpers.formatPhoneNumber(row.phone) + (_.size(row.phoneExtension) === 0 ? '' : ' x' + row.phoneExtension)) : 'N/A';

                        if (row.phone !== '')
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                        html += '<div class="flex-fill ' + (row.phone ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                        html += '</div>';
                        return html;
                    }, this)
                },
                {
                    "data": "email",
                    "title": "Email",
                    "orderable": false
                }
            ]
        });

    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    mergeContacts: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'addressbook',
            },
            {
                endpoint: 'merge'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                destinationContactId: this.destinationSelectPicker.getValue(),
                contacts: this.options.addressBookView.selectedContactsAll
            }
        }).post().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Contacts merged successfully.'
            });

            if (typeof this.options.onMerge === 'function')
                this.options.onMerge();

            this.removeModal();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });

    }
});

PJQ.views.addressbook.QualificationsReportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Qualifications-Report'),
        minWidth: '500px'
    },
    events: {
        'click .btn-continue': 'export',
        'keyup .email': 'emailChanged'
    },
    afterRender: function () {
        new PJQ.Alert(this.$('.email-alert'), {
            text: 'Please enter your email address, and the report will be sent to you when it is ready.'
        });

        this.$('.email').val(PJQ.app.session.user.get('email'));
        this.emailChanged();
    },
    emailChanged: function () {
        this.$('.btn-continue').prop('disabled', this.$('.email').val().indexOf('@') <= 0);
    },
    export: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'reports',
            },
            {
                endpoint: 'qualification_screenings'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                options: [
                    {
                        id: _.unique(),
                        type: 'STRING',
                        name: 'email',
                        isRequired: true,
                        defaultValue: {
                            email: this.$('.email').val().trim()
                        },
                        value: this.$('.email').val().trim()
                    }
                ]
            }
        }).post().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Report processing - you will receive an email with the report attached when it is ready.'
            });

            this.removeModal();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });

    }
});
